export enum CALENDAR_TYPES {
  single="single",
  range="range"
}
